<template>
  <TimeslotDashboardLayout>
    <div class="main-content">
      <div class="welcome-wrappr">
        <div class="text-block-13">
          Hello, {{ userInfo.customerFirstName }}
          {{ userInfo.customerLastName }}
        </div>
        <div class="text-block-14">Welcome to Timeslate 👋</div>
      </div>
      <div class="profile-setup-wrapper">
        <div class="header">
          <div class="text-block-15">Let’s start with the basics 🥳</div>
        </div>
        <div class="paragraph-wrapper">
          <div
            class="paragraph"
            style="font-family: 'Galano grotesque-Medium', sans-serif; "
          >
            <!--            Complete your profile setup by providing the information below.-->
            Take the steps below to complete your profile setup
          </div>
          <div class="paragraph-copy">{{ progress }}/3 completed</div>
        </div>
        <div class="progress-bar-wrapper">
          <div
            class="progress-indicator"
            :style="{ width: progressWidth }"
          ></div>
        </div>
        <div class="steps">
          <FormulateInput
            type="radio"
            label="Complete your personal details"
            name="radio-item-profile"
            :class="updateProfile ? 'progress-checked label' : 'progress-check'"
            id="personal-details"
            :value="updateProfile"
            :checked="updateProfile"
            @click="completeProfile"
          />
          <FormulateInput
            type="radio"
            label="Add your account information"
            :class="updateClient ? 'progress-checked label' : 'progress-check'"
            id="client-profile"
            name="radio-item-education"
            :value="updateClient"
            :checked="updateClient"
            @click="completeClient"
          />
          <FormulateInput
            type="radio"
            label="Book your first consultation"
            name="radio-item-employment"
            :class="
              updateConsultation ? 'progress-checked label' : 'progress-check'
            "
            id="first-consultation"
            :value="updateConsultation"
            :checked="updateConsultation"
            @click="completeConsultation"
          />
        </div>
      </div>
      <div class="top-professional">
        <section class="section-testimonial28">
          <div class="page-padding-2">
            <div class="container-large">
              <div class="padding-vertical padding-xhuge">
                <div class="margin-bottom margin-xxlarge">
                  <div class="max-width-large">
                    <div class="margin-bottom margin-small">
                      <h2 class="heading-2">Top professionals</h2>
                    </div>
                  </div>
                </div>
                <div
                  data-delay="4000"
                  data-animation="slide"
                  class="testimonial28_component w-slider"
                  data-autoplay="false"
                  data-easing="ease"
                  data-hide-arrows="false"
                  data-disable-swipe="false"
                  data-autoplay-limit="0"
                  data-nav-spacing="3"
                  data-duration="500"
                  data-infinite="true"
                >
                  <div class="testimonial28_mask w-slider-mask">
                    <div
                      class="testimonial28_slide w-slide"
                      v-for="(professional, index) in professionalList.slice(
                        0,
                        6
                      )"
                      :key="index"
                    >
                      <!--                      <a-->
                      <!--                        @click="profile(professional)"-->
                      <!--                        :style="sliding ? slideInactive : slideActive"-->
                      <!--                        class="testimonial28_content w-inline-block"-->
                      <!--                      >-->
                      <!--                        <div class="div-block-16">-->
                      <!--                          <div class="text-block-16">-->
                      <!--                            {{ professional.customerName }}-->
                      <!--                          </div>-->
                      <!--                          <div class="text-block-17">-->
                      <!--                            {{ professional.professionalSubCategory }}-->
                      <!--                          </div>-->
                      <!--                        </div>-->
                      <!--                      </a>-->
                      <div
                        class="ejzqWn"
                        :key="index"
                        @click="profile(professional)"
                        :style="sliding ? slideInactive : slideActive"
                      >
                        <img
                          class="ejzqWn"
                          :src="
                            professional.customerDisplayPicture ||
                              'https://apvertise-repo.s3.amazonaws.com/logo23470493927891664919183983.jpeg'
                          "
                        />
                        <div class="overlay">
                          <div class="details">
                            <p class=" text-block-16">
                              {{ professional.customerName }}
                            </p>
                            <div class="details__items">
                              <div class=" text-block-17">
                                <span>{{
                                  professional.professionalSubCategory
                                }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--                      <a href="#" class="link-block-2 w-inline-block"></a>-->
                    </div>
                  </div>
                  <div
                    class="testimonial28_arrow left w-slider-arrow-left"
                    @click="moveLeft"
                  >
                    <img
                      src="@/assets/timeslot-images/right1.svg"
                      loading="lazy"
                      alt=""
                    />
                  </div>
                  <div
                    class="testimonial28_arrow w-slider-arrow-right"
                    @click="moveRight"
                  >
                    <img
                      src="@/assets/timeslot-images/left.svg"
                      loading="lazy"
                      alt=""
                    />
                  </div>
                  <div
                    class="testimonial28_slide-nav w-slider-nav w-slider-nav-invert w-round"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <!--      <div class="bookings-wrapper">-->
      <!--        <div class="booking-header-wrapper">-->
      <!--          <div>-->
      <!--            <div class="text-block-18">Bookings</div>-->
      <!--          </div>-->
      <!--          <div class="s-width">-->
      <!--            <FormulateInput-->
      <!--              type="select"-->
      <!--              name="bookingStatus"-->
      <!--              validation-name="Country"-->
      <!--              placeholder="All"-->
      <!--              :options="['All', 'Upcoming', 'Past']"-->
      <!--              v-model="type"-->
      <!--            />-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div>-->
      <!--          <div v-for="(booking, index) in bookingInfo" :key="index">-->
      <!--            <div class="bookings-list-wrapper _1">-->
      <!--              <div class="div-block-24">-->
      <!--                <div class="text-block-24">-->
      <!--                  Consultation Session with-->
      <!--                  <router-link-->
      <!--                    to="/professional-profile"-->
      <!--                    class="link-5 capital"-->
      <!--                    >{{ booking.professionalName }}</router-link-->
      <!--                  >-->
      <!--                </div>-->
      <!--                <div class="div-block-22">-->
      <!--                  <div class="div-block-23">-->
      <!--                    <img-->
      <!--                      src="@/assets/timeslot-images/calendar.svg"-->
      <!--                      loading="lazy"-->
      <!--                      alt=""-->
      <!--                      class="image-7"-->
      <!--                    />-->

      <!--                    <div>-->
      <!--                      {{-->
      <!--                        new Date(booking.bookingStartTime.slice(0, 10))-->
      <!--                          .toString()-->
      <!--                          .slice(0, 11)-->
      <!--                      }}-->
      <!--                    </div>-->
      <!--                  </div>-->
      <!--                  <div class="div-block-23">-->
      <!--                    <img-->
      <!--                      src="@/assets/timeslot-images/clock.svg"-->
      <!--                      loading="lazy"-->
      <!--                      alt=""-->
      <!--                      class="image-8"-->
      <!--                    />-->
      <!--                    <div>-->
      <!--                      {{ formatHours(new Date(booking.bookingStartTime)) }}:{{-->
      <!--                        formatMinutes(new Date(booking.bookingStartTime))-->
      <!--                      }}-->
      <!--                      {{ formatTime(new Date(booking.bookingStartTime)) }} - -->
      <!--                      {{ formatHours(new Date(booking.bookingEndTime)) }}:{{-->
      <!--                        formatMinutes(new Date(booking.bookingEndTime))-->
      <!--                      }}-->
      <!--                      {{ formatTime(new Date(booking.bookingEndTime)) }}-->
      <!--                    </div>-->
      <!--                  </div>-->
      <!--                  <div class="div-block-23">-->
      <!--                    <img-->
      <!--                      src="@/assets/timeslot-images/dollar.svg"-->
      <!--                      loading="lazy"-->
      <!--                      alt=""-->
      <!--                      class="image-9"-->
      <!--                    />-->
      <!--                    <div>-->
      <!--                      {{ booking.bookingAmount }} USD ({{-->
      <!--                        booking.bookingSlots-->
      <!--                      }}-->
      <!--                      Slots)-->
      <!--                    </div>-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--              <div-->
      <!--                class="div-block-25"-->
      <!--                v-if="show && booking.bookingStatus.toLowerCase() === 'past'"-->
      <!--              >-->
      <!--                <div class="professional-detail-wrapper">-->
      <!--                  <div class="professional-name-wraper">-->
      <!--                    <div class="text-block-25">Professional:</div>-->
      <!--                    <div class="div-block-26">-->
      <!--                      <div>-->
      <!--                        <img-->
      <!--                          src="@/assets/timeslot-images/profile-picture.png"-->
      <!--                          loading="lazy"-->
      <!--                          width="45"-->
      <!--                          alt=""-->
      <!--                          class="image-10"-->
      <!--                        />-->
      <!--                      </div>-->
      <!--                      <div>-->
      <!--                        <div class="text-block-26">-->
      <!--                          {{ booking.professionalName }}-->
      <!--                        </div>-->
      <!--                        <div class="prof-role">-->
      <!--                          {{ booking.professionalSubCategory }}-->
      <!--                        </div>-->
      <!--                      </div>-->
      <!--                    </div>-->
      <!--                  </div>-->
      <!--                  <div class="professional-name-wraper">-->
      <!--                    <div class="text-block-25">Professional’s TimeZone</div>-->
      <!--                    <div class="div-block-26">-->
      <!--                      <div>-->
      <!--                        <div class="text-block-26">-->
      <!--                          {{ booking.customerTimezone }}-->
      <!--                        </div>-->
      <!--                      </div>-->
      <!--                    </div>-->
      <!--                  </div>-->
      <!--                  <div class="professional-name-wraper">-->
      <!--                    <div class="text-block-25">Topic</div>-->
      <!--                    <div class="div-block-26">-->
      <!--                      <div>-->
      <!--                        <div class="text-block-26">-->
      <!--                          {{ booking.bookingTopic }}-->
      <!--                        </div>-->
      <!--                      </div>-->
      <!--                    </div>-->
      <!--                  </div>-->
      <!--                  <div class="professional-name-wraper">-->
      <!--                    <div class="text-block-25">Your Message</div>-->
      <!--                    <div class="div-block-26">-->
      <!--                      <div>-->
      <!--                        <p class="paragraph-2">-->
      <!--                          {{ booking.bookingMessage }}-->
      <!--                        </p>-->
      <!--                      </div>-->
      <!--                    </div>-->
      <!--                  </div>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--              <a-->
      <!--                data-w-id="94baf665-e556-40da-3a06-171ac8cf209f"-->
      <!--                href=""-->
      <!--                class="button-4 view w-button"-->
      <!--                v-if="booking.bookingStatus.toLowerCase() === 'past' && !show"-->
      <!--                @click="toggleShow"-->
      <!--                >View details</a-->
      <!--              >-->
      <!--              <a-->
      <!--                data-w-id="ab42646a-d67b-0418-bb58-913229f01db3"-->
      <!--                href=""-->
      <!--                class="button-4 hide w-button"-->
      <!--                v-if="show && booking.bookingStatus.toLowerCase() === 'past'"-->
      <!--                @click="toggleShow"-->
      <!--                >Hide details</a-->
      <!--              >-->
      <!--              <div-->
      <!--                class="div-block-27"-->
      <!--                v-if="booking.bookingStatus.toLowerCase() === 'upcoming'"-->
      <!--              >-->
      <!--                &lt;!&ndash;                <a&ndash;&gt;-->
      <!--                &lt;!&ndash;                  data-w-id="2065374d-5d24-0aa2-434f-6db1a4595b1e"&ndash;&gt;-->
      <!--                &lt;!&ndash;                  href=""&ndash;&gt;-->
      <!--                &lt;!&ndash;                  class="button-4 outline w-button"&ndash;&gt;-->
      <!--                &lt;!&ndash;                  >Message</a&ndash;&gt;-->
      <!--                &lt;!&ndash;                >&ndash;&gt;-->
      <!--                <a-->
      <!--                  data-w-id="d2905c7f-aa31-0fd3-a58f-fdc73a5cb049"-->
      <!--                  href=""-->
      <!--                  class="button-4 outline w-button"-->
      <!--                  >Reschedule</a-->
      <!--                >-->
      <!--                <a-->
      <!--                  data-w-id="040a7e13-c7c7-51ec-c032-ad96cbc8f405"-->
      <!--                  href=""-->
      <!--                  class="button-4-copy outline w-button"-->
      <!--                  >Cancel</a-->
      <!--                >-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->

      <!--        <div class="bookings-empty-state" v-if="bookingInfo.length === 0">-->
      <!--          <div class="div-block-19">-->
      <!--            <img-->
      <!--              src="@/assets/timeslot-images/Empty-booking.svg"-->
      <!--              loading="lazy"-->
      <!--              alt=""-->
      <!--              class="image-6"-->
      <!--            />-->
      <!--            <div class="text-block-20">Nothing to show here</div>-->
      <!--            <div class="text-block-21">-->
      <!--              Appointments with professionals would show up here-->
      <!--            </div>-->
      <!--            <router-link-->
      <!--              to="/discover-professionals"-->
      <!--              class="timeslot-button w-button"-->
      <!--              >Explore professionals</router-link-->
      <!--            >-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <!--    <ReviewWarningModal :review-close="warningReview" />-->
  </TimeslotDashboardLayout>
</template>

<script>
import TimeslotDashboardLayout from "@/views/timeslot/TimeslotDashboardLayout";
import { mapState } from "vuex";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import BookingRequest from "@/model/requests/BookingRequest";
import BookingResponse from "@/model/responses/BookingResponse";
import moment from "moment";
// import ReviewWarningModal from "@/components/modal/ReviewWarningModal";
export default {
  name: "CustomerDashboard",
  components: { TimeslotDashboardLayout },
  data() {
    return {
      nav: false,
      show: false,
      show2: false,
      sliding: false,
      readModel: BookingRequest.readByCustomerId,
      type: "All",
      warningReview: false,
      bookingsPerCustomer: BookingResponse.readByCustomerId.data,
      slideActive: {
        transform: "translateX(-700px)",
        opacity: "1",
        transition: "transform 1000ms ease 0s"
      },
      slideInactive: {
        transform: "translateX(0px)",
        opacity: "1",
        transition: "transform 1000ms ease 0s"
      },
      send: false
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      professionalList: state => state.professional.professionals,
      bookings: state => state.booking.bookings,
      bookingInfo: state => state.booking.bookingInfo,
      singleBooking: state => state.booking.singleBooking,
      customerInfo: state => state.customer.customerInfo,
      professionals: state => state.professional.professionals,
      pendingReviews: state => state.booking.pendingReviews,
      customerToProfessionalId: state =>
        state.professional.customerToProfessionalId
    }),
    upcomingBookings() {
      return this.bookingInfo.filter(
        item => item.bookingStatus.toLowerCase() === "upcoming" || "active"
      );
    },
    pastBookings() {
      return this.bookingInfo.filter(
        item => item.bookingStatus.toLowerCase() === "past"
      );
    },
    updateProfile() {
      return (
        ("customerDisplayPicture" in this.customerInfo ||
          "customerDisplayPicture" in this.userInfo) &&
        ("customerTimezone" in this.customerInfo ||
          "customerDisplayPicture" in this.userInfo) &&
        ("customerAbout" in this.customerInfo ||
          "customerAbout" in this.userInfo) &&
        ("customerInterest" in this.customerInfo ||
          "customerInterest" in this.userInfo)
      );
    },
    updateClient() {
      return (
        ("payOutAccountNumber" in this.customerInfo ||
          "payOutAccountNumber" in this.userInfo) &&
        ("payOutAccountBank" in this.customerInfo ||
          "payOutAccountBank" in this.userInfo)
      );
    },
    updateConsultation() {
      return (
        this.userInfo.booking.length !== 0 || this.bookingInfo.length !== 0
      );
    },

    setProgressBar() {
      let value = 0;
      if (this.updateProfile) {
        value += 1;
      }
      if (this.updateClient) {
        value += 1;
      }
      if (this.updateConsultation) {
        value += 1;
      }
      return value;
    },
    progress() {
      return `${this.setProgressBar}`;
    },
    progressWidth() {
      let barWidth = this.setProgressBar * 33.34;
      return `${barWidth}%`;
    }
  },
  watch: {
    type(newValue) {
      if (
        newValue.toLowerCase() === "upcoming" ||
        newValue.toLowerCase() === "active"
      ) {
        StoreUtils.commit(
          "booking/updateBookingInfo",
          (this.bookingInfo = this.singleBooking.filter(
            item => item.bookingStatus.toLowerCase() === "upcoming"
          ))
        );
      } else if (newValue.toLowerCase() === "past") {
        StoreUtils.commit(
          "booking/updateBookingInfo",
          (this.bookingInfo = this.singleBooking.filter(
            item => item.bookingStatus.toLowerCase() === "past"
          ))
        );
      } else if (newValue.toLowerCase() === "all") {
        StoreUtils.commit(
          "booking/updateBookingInfo",
          (this.bookingInfo = this.singleBooking)
        );
      }
    }
  },
  methods: {
    moveLeft() {
      this.sliding = false;
    },
    moveRight() {
      this.sliding = true;
    },
    openNav() {
      this.nav = true;
    },
    toggleNav() {
      this.nav = !this.nav;
    },
    openShow() {
      this.show = true;
    },
    toggleShow() {
      this.show = !this.show;
    },
    toggleShow2() {
      this.show2 = !this.show2;
    },
    profile(professional) {
      StoreUtils.commit(
        StoreUtils.mutations.professional.SET_PROFESSIONAL,
        professional
      );
      StoreUtils.commit(
        "professional/updateProfessionalId",
        professional.professionalId
      );
      RouterUtils.changeRouteUrlTo(
        `/professionals/${professional.professionalId}`
      );
    },
    completeProfile() {
      if (!this.updateProfile) {
        RouterUtils.changeRouteTo(RouterUtils.routes.auth.CUSTOMER_SETTINGS);
      }
    },
    completeClient() {
      if (!this.updateClient) {
        RouterUtils.changeRouteTo(RouterUtils.routes.auth.CUSTOMER_SETTINGS);
      }
    },
    completeConsultation() {
      if (!this.updateConsultation) {
        RouterUtils.changeRouteTo(RouterUtils.routes.auth.CUSTOMER_BOOKINGS);
      }
    },
    formattedDate(date) {
      return moment(date).format("LT");
    },
    formatDate(date) {
      return moment(date).format("ll");
    },
    formatTime(date) {
      return moment(date).format("a");
    },
    formatMinutes(date) {
      return moment(date).format("mm");
    },
    formatHours(date) {
      return moment(date).format("h");
    }
  },
  created() {
    this.readModel.bookingCustomerId = this.userInfo.customerId;
    StoreUtils.dispatch(
      StoreUtils.actions.booking.READ_BY_BOOKING_CUSTOMER_ID,
      this.readModel
    );
    if (this.pendingReviews.length !== 0) {
      this.warningReview = true;
    }
  },
  mounted() {}
};
</script>

<style scoped>
.s-width {
  width: 20%;
}
.capital {
  text-transform: capitalize;
}

.progress-check {
  color: #031c43;
  font-size: 16px;
  line-height: 20px;
  margin: 0;
  font-family: "Galano grotesque-Light", sans-serif;
  cursor: pointer;
}
.progress-checked label {
  text-decoration: line-through;
  color: #031c43;
  font-size: 16px;
  line-height: 20px;
  margin: 0;
  font-family: "Galano grotesque-Light", sans-serif;
  cursor: pointer;
}

.ejzqWn {
  width: 215px;
  height: 250px;
  display: block;
  overflow: hidden;
  position: relative;
  border-radius: 16px;
  text-decoration: none;
  border: 0.5px solid rgba(105, 105, 105, 0.6);
  cursor: pointer;
}
.ejzqWn:hover,
.ejzqWn:active {
  transform: scale(1.05);
}
.ejzqWn .overlay {
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  padding: 20px 24px;
  position: absolute;
  flex-direction: column;
  transition: all 0.25s ease 0s;
  background-image: linear-gradient(transparent 0%, rgba(0, 0, 0, 0.5));
}
.ejzqWn .top-items {
  display: grid;
  grid-auto-flow: column;
  gap: 6px;
}
.ejzqWn .top-items .favorited {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
}
.dwCcQI .favorited,
.dwCcQI .details__items .item:nth-child(2) {
  display: none !important;
}
.ejzqWn .details {
  margin-top: auto;
  color: rgb(255, 255, 255);
}

.ejzqWn .details p {
  margin-bottom: 0px;
}
.ejzqWn .details__name {
  font-weight: 700;
  line-height: 18px;
}

.ejzqWn .details__items {
  /*margin-top: 10px;*/
}

.ejzqWn .details__items .item:first-child {
  margin-top: 0px;
}
.ejzqWn .details__items .item {
  display: flex;
  font-size: 14px;
  margin-top: 4px;
  line-height: 1.6;
}
</style>
